import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { AppConfig } from 'AppConfig';
import axios from 'axios';
import { FoMaterialTable } from 'common/FoMaterialTable';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../actions/Actions';
import StopLossMGUSelection from './stopLossMGUSelection';

const StopLossMGU = ({ tenantId }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.masterTable.tenantSLMGUs);
  const isLoading = useSelector((state) => state.masterTable.slmguLoading);

  const [open, setOpen] = useState(false);

  const handleOpenSelection = () => {
    setOpen(true);
  };

  const handleSaveSelection = (rows) => {
    if (rows && Array.isArray(rows) && rows.length > 0) {
      let tpas = [];

      rows.forEach((item) => {
        tpas.push({
          name: item.name,
          tenantId: tenantId
        });
      });

      axios
        .post(
          AppConfig.API_BASE_URL + 'slmgu/addlist',
          tpas,
          AppConfig.POST_HEADERS
        )
        .then((m) => {
          refresh();
          setOpen(false);
        })
        .catch((err) => console.log(err));
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const deleteSelected = (row) => {
    let ids = [];

    row.forEach((item) => {
      ids.push(item.id);
    });
    if (ids && Array.isArray(ids) && ids.length > 0) {
      axios
        .delete(AppConfig.API_BASE_URL + `slmgu/mult`, { data: ids })
        .then((m) => {
          refresh();
        })
        .catch((err) => console.log(err));
    }
  };

  const refresh = () => {
    dispatch({
      type: Actions.MASTER_TABLE_GET_SLMGU_FOR_TENENT
    });
    axios
      .get(AppConfig.API_BASE_URL + `slmgu`)
      .then((m) => {
        dispatch({
          type: Actions.MASTER_TABLE_GET_SLMGU_FOR_TENENT_SUCCESS,
          data: m.data
        });
      })
      .catch((err) =>
        dispatch({
          type: Actions.MASTER_TABLE_GET_SLMGU_FOR_TENENT_FAILURE
        })
      );
  };

  useEffect(() => {
    refresh();
  }, [tenantId]);

  return (
    <>
      <FoMaterialTable
        title="SL MGU"
        isLoading={isLoading}
        columns={[{ title: 'Name', field: 'name' }]}
        data={data}
        options={{
          selection: true
        }}
        components={{ OverlayLoading: () => <div /> }}
        actions={[
          {
            icon: () => <AddIcon />,
            tooltip: 'Add',
            isFreeAction: true,
            onClick: (event) => handleOpenSelection()
          },
          {
            tooltip: 'Delete',
            icon: () => <DeleteIcon />,
            onClick: (evt, data) => deleteSelected(data)
          }
        ]}
      />

      <StopLossMGUSelection
        open={open}
        onSave={handleSaveSelection}
        onClose={handleClose}
        tenantId={tenantId}
      />
    </>
  );
};

export default StopLossMGU;
